import React from "react";
import Loading from "../../components/elements/loading";

const LoadingPage: React.FunctionComponent = () => {
    return (
        <Loading loading={true}/>
    )
}
export default LoadingPage;